import { render, staticRenderFns } from "./ThemeSettingAdd.vue?vue&type=template&id=57bc6a03"
import script from "./ThemeSettingAdd.vue?vue&type=script&lang=js"
export * from "./ThemeSettingAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports